import CitySEOHead from "@/components/feature/CitySEOHead";
import NewnanHeroSection from "./components/HeroSection";
import NewnanStickyNav from "./components/StickyNav";
import NewnanProcessingTimeSection from "./components/ProcessingTimeSection";
import NewnanServicesSection from "./components/ServicesSection";
import NewnanHowItWorksSection from "./components/HowItWorksSection";
import NewnanLocalAreaSection from "./components/LocalAreaSection";
import NewnanAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import NewnanComparisonSection from "./components/ComparisonSection";
import NewnanMistakesSection from "./components/MistakesSection";
import NewnanTestimonialsSection from "./components/TestimonialsSection";
import NewnanFAQSection, { faqs } from "./components/FAQSection";
import NewnanHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import NewnanFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function NewnanPage() {
  return (
    <main>
      <CitySEOHead
        city="Newnan"
        state="Georgia"
        stateAbbr="GA"
        route="/cities/newnan"
        title="Emergency Passport Newnan, GA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Newnan, GA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Coweta County and southwest Atlanta suburban travelers. Get your emergency passport fast!"
        keywords="expedited passport, emergency passport, Newnan passport, same day passport Newnan, fast passport Georgia, Coweta County passport"
        geoPlacename="Newnan, Georgia"
        geoPosition="33.3807;-84.7997"
        faqs={faqs}
        servicesSchema={[]}
        statePageName="Georgia"
        statePageRoute="/states/georgia"
      />
      <NewnanHeroSection />
      <NewnanStickyNav />
      <NewnanProcessingTimeSection />
      <NewnanServicesSection />
      <NewnanHowItWorksSection />
      <NewnanLocalAreaSection />
      <NewnanAcceptanceFacilitiesSection />
      <NewnanComparisonSection />
      <NewnanMistakesSection />
      <NewnanTestimonialsSection />
      <NewnanFAQSection />
      <NewnanHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/newnan" state="GA" />
      <NewnanFinalCTA />
    </main>
  );
}